import { api } from "./client.js";

const D = "/api/v1/dashboard";

export interface Submission {
  bot_id: string;
  bot_name: string;
  session_id: string;
  trigger_id: string;
  trigger_intent: string;
  variables: Record<string, string>;
  conversation_summary?: string;
  created_at: string;
  user_agent?: string;
  session_type?: string;
  origin_domain?: string;
  message_count?: number;
}

export interface SubmissionsResponse {
  submissions: Submission[];
  total: number;
  this_week: number;
  by_bot: Array<{ bot_id: string; bot_name: string; count: number }>;
  by_intent: Array<{ intent: string; count: number }>;
  bots: Array<{ bot_id: string; name: string }>;
}

export interface SubmissionsFilter {
  bot_id?: string;
  intent?: string;
  date_from?: string;
  date_to?: string;
}

export const submissionsApi = {
  list: (filters: SubmissionsFilter = {}) => {
    const params = new URLSearchParams();
    if (filters.bot_id)    params.set("bot_id",    filters.bot_id);
    if (filters.intent)    params.set("intent",    filters.intent);
    if (filters.date_from) params.set("date_from", filters.date_from);
    if (filters.date_to)   params.set("date_to",   filters.date_to);
    const qs = params.toString();
    return api.get<SubmissionsResponse>(`${D}/submissions${qs ? `?${qs}` : ""}`);
  },
};
